<div style="padding: 24px;">
  <form #searchForm="ngForm" (ngSubmit)="applySearch()">
  <div class="row no-padding">
    <div class="col-md-3 col-left">
      <mat-form-field appearance="fill" class="input-field" floatLabel="always" style="width:100%">
        <mat-label>{{'Dossier.Dossiernummer' | translate}}</mat-label>
        <input matInput name="Dossiernummer" [(ngModel)]="search.Dossiernummer" type="text" autocomplete='off' (change)="applySearch()">
        @if (search.Dossiernummer) {
          <button matSuffix mat-icon-button type="button" (click)="search.Dossiernummer = ''"><mat-icon>close</mat-icon></button>
        }
      </mat-form-field>
    </div>

    <div class="col-md-3 col-middle">
      <mat-form-field appearance="fill" class="input-field" floatLabel="always" style="width:100%">
        <mat-label>{{'Dossier.Rechnungsnummer' | translate}}</mat-label>
        <input matInput name="RechnungsNr" [(ngModel)]="search.RechnungsNr" type="text" autocomplete='off' (change)="applySearch()" >
        @if (search.RechnungsNr) {
          <button matSuffix mat-icon-button type="button" (click)="search.RechnungsNr = ''"><mat-icon>close</mat-icon></button>
        }
      </mat-form-field>
    </div>

    <div class="col-md-3 col-right">
      <mat-form-field appearance="fill" class="input-field" floatLabel="always" style="width:100%">
        <mat-label>{{'Dossier.Portfolio' | translate}}</mat-label>
        <mat-select name="Art" [(ngModel)]="search.Art" (selectionChange)="applySearch()">
          <mat-option [value]="1">{{'Dossier.Inkasso' | translate}}</mat-option>
          <mat-option [value]="2">{{'Dossier.Verlustscheine' | translate}}</mat-option>
          <mat-option [value]="3">{{'Dossier.Erbrecherche' | translate}}</mat-option>
          <mat-option [value]="4">{{'Dossier.Auslandsinkasso' | translate}}</mat-option>
          <mat-option [value]="0">{{'Dossier.Alle' | translate}}</mat-option>
        </mat-select>
        @if (search.Art) {
          <button matSuffix mat-icon-button type="button" (click)="clearPortfolio()"><mat-icon>close</mat-icon></button>
        }
      </mat-form-field>
    </div>
  </div>

  <div class="row no-padding">
    <div class="col-md-3 col-left">
      <mat-form-field appearance="fill" class="input-field" floatLabel="always" style="width:100%">
        <mat-label>{{'Dossier.Dossierstatus' | translate}}</mat-label>
        <mat-select name="searchStatus" [(ngModel)]="searchStatus" multiple (selectionChange)="applySearch()" [disableOptionCentering]="true">
          <mat-option [value]="1" [disabled]="isNotInvoicedOptionDisabled()">{{'Dossier.NichtAbgerechnet' | translate}}</mat-option>
          <mat-option [value]="2" [disabled]="isInvoicedOptionDisabled()">{{'Dossier.Abgerechnet' | translate}}</mat-option>
          <mat-option [value]="3" [disabled]="isPostMigrationOptionDisabled()">{{'Dossier.NachMigration' | translate}}</mat-option>
          <mat-option [value]="4" [disabled]="isPreMigrationOptionDisabled()">{{'Dossier.VorMigration' | translate}}</mat-option>
        </mat-select>
        @if (searchStatus?.length > 0) {
          <button matSuffix mat-icon-button type="button" (click)="clearSearchStatus()"><mat-icon>close</mat-icon></button>
        }
      </mat-form-field>
    </div>

    <div class="col-md-3 col-middle">
      <mat-form-field appearance="fill" class="input-field" floatLabel="always" subscriptSizing="dynamic" style="width:100%">
        <mat-label>{{'Dossier.MinimumAmount' | translate}}</mat-label>
        <input matInput #minimumAmountModel="ngModel" name="MinimumAmount" [(ngModel)]="search.MinimumAmount" currencyValidator maxOverMinValidator [maximumAmountRange]="search.MaximumAmount" type="text" inputmode="decimal" autocomplete="off" (change)="applySearch()">
        @if (hasMinimumAmountFilter()) {
          <button matSuffix mat-icon-button type="button" (click)="clearMinimumAmountFilter()"><mat-icon>close</mat-icon></button>
        }
        @if (minimumAmountModel.hasError('invalidAmount')) {
          <mat-error class="amount-filter-error" role="alert"><span>{{'Dossier.InvalidAmount' | translate}}</span></mat-error>
        }
        @if (minimumAmountModel.hasError('invalidAmountRange')) {
          <mat-error class="amount-filter-error" role="alert"><span>{{'Dossier.InvalidAmountRange' | translate}}</span></mat-error>
        }
      </mat-form-field>
    </div>

    <div class="col-md-3 col-middle">
      <mat-form-field appearance="fill" class="input-field" floatLabel="always" subscriptSizing="dynamic" style="width:100%">
        <mat-label>{{'Dossier.MaximumAmount' | translate}}</mat-label>
        <input matInput #maximumAmountModel="ngModel" name="MaximumAmount" [(ngModel)]="search.MaximumAmount" currencyValidator type="text" inputmode="decimal" autocomplete="off" (change)="applySearch()">
        @if (hasMaximumAmountFilter()) {
          <button matSuffix mat-icon-button type="button" (click)="clearMaximumAmountFilter()"><mat-icon>close</mat-icon></button>
        }
        @if (maximumAmountModel.hasError('invalidAmount')) {
          <mat-error class="amount-filter-error" role="alert"><span>{{'Dossier.InvalidAmount' | translate}}</span></mat-error>
        }
      </mat-form-field>
    </div>

    <div class="col-md-3 col-right">
      @if (hasPractitioners()) {
        <mat-form-field appearance="fill" class="input-field"
          floatLabel="always" style="width:100%">
          <mat-label>{{'Neuauftrag.Behandler' | translate}}</mat-label>
          <mat-select name="Behandler" [(ngModel)]="search.Behandler" (selectionChange)="applySearch()">
            <mat-option [value]="0">{{'Dossier.KeinBehandler' | translate}}</mat-option>
            <mat-option [value]="-1">{{'Dossier.Alle' | translate}}</mat-option>
            @for (practitioner of practitioners; track practitioner) {
              <mat-option [value]="practitioner?.Id">
                {{getPractitionerName(practitioner?.Id)}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
    </div>

    <div class="row no-padding">
      <div class="col-md-3 col-left">
        <mat-form-field appearance="fill" class="input-field" floatLabel="always" style="width:100%">
          <mat-label>{{'Vorname' | translate}}</mat-label>
          <input matInput name="VornameRE" [(ngModel)]="search.VornameRE" type="text" autocomplete='off' (change)="applySearch()">
          @if (search.VornameRE) {
            <button matSuffix mat-icon-button type="button" (click)="search.VornameRE = ''"><mat-icon>close</mat-icon></button>
          }
        </mat-form-field>
      </div>

      <div class="col-md-3 col-middle">
        <mat-form-field appearance="fill" class="input-field" floatLabel="always" style="width:100%">
          <mat-label>{{'Name' | translate}}</mat-label>
          <input matInput name="NameRE" [(ngModel)]="search.NameRE" type="text" autocomplete='off' (change)="applySearch()">
          @if (search.NameRE) {
            <button matSuffix mat-icon-button type="button" (click)="search.NameRE = ''"><mat-icon>close</mat-icon></button>
          }
        </mat-form-field>
      </div>

      <div class="col-md-3 col-right">
        <mat-form-field appearance="fill" class="input-field" floatLabel="always" style="width:100%">
          <mat-label>{{'Login.Kontakt.Anschrift' | translate}}</mat-label>
          <input matInput name="AnschriftRE" [(ngModel)]="search.AnschriftRE" type="text" autocomplete='off' (change)="applySearch()">
          @if (search.AnschriftRE) {
            <button matSuffix mat-icon-button type="button" (click)="search.AnschriftRE = ''"><mat-icon>close</mat-icon></button>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="row no-padding" style="margin-bottom: 16px;">
      <button mat-flat-button class="button-standard" color="primary" matSuffix type="submit">
        <mat-icon>search</mat-icon> {{'Suchen' | translate}}
      </button>

      <button mat-button class="button-standard" color="primary" type="button" (click)="clearSearch()" [disabled]="!canClearSearch()">
        <mat-icon>clear</mat-icon>&nbsp;{{'EingabenLoeschen' | translate}}
      </button>

      <button mat-button class="button-standard" color="primary" type="button" (click)="downloadExcel()" [disabled]="!canDownload()">
        <mat-icon>get_app</mat-icon>&nbsp;Download
      </button>

      <button mat-button class="button-standard" color="primary" type="button" (click)="withdrawLossCertificates()"
              [disabled]="isLossCertificateWithdrawalInProgress || !canWithdrawLossCertificates()">
        <mat-icon>do_not_disturb_on</mat-icon>&nbsp;{{ 'LossCertificates.BulkWithdrawalTitle' | translate }}
        @if (isLossCertificateWithdrawalInProgress) {
        <mat-icon style="margin-left: 8px;"><mat-spinner diameter="18"></mat-spinner></mat-icon>
        }
      </button>
    </div>
  </form>

    @if (this.update) {
      <div>
        <mat-progress-bar mode="indeterminate" style="margin-top: 4px; margin-bottom: 4px;"></mat-progress-bar>
      </div>
    }

    @if (!this.update && cases.length == 0) {
      <div class="row no-padding">
        {{'NoResult' | translate}}
      </div>
    }

    @if (cases.length > 0) {
      <div class="row no-padding">
        <mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" style="width: 100%;" class="mat-elevation-z2">
          <ng-container matColumnDef="selection">
            <mat-header-cell *matHeaderCellDef>
              <mat-checkbox style="margin-left: 12px; margin-top: 4px;" color="primary" [(ngModel)]="allSelected"
                (click)="toggleSelection()">
              </mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let item" (click)="$event.stopPropagation()">
              <mat-checkbox style="margin-left: 12px; margin-top: 4px;" color="primary"
              [(ngModel)]="item.Selected"></mat-checkbox>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="Id">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
                {{'Dossier.Dossiernummer' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let item">
              <div class="case-id-cell">
                <span>{{ item.DossierNr }}</span>
                @if (item.CanWithdrawLossCertificate) {
                <span class="under-management-hint">
                  {{'LossCertificates.IsUnderManagementHint' | translate }}
                </span>
                }
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="Status">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Dossieransicht.Status' | translate}}</mat-header-cell>
            <mat-cell *matCellDef="let item">{{getStatusKey(item.Status) | translate}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="Rechnungsnummern">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Dossier.Rechnungsnummer' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let item">
            {{item.Rechnungsnummern}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="Betrag">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="amount-cell">{{'Dossier.Betrag' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let item" class="amount-cell">
            {{item.Betrag | currency:'CHF':'code':'1.2-2'}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="Rechnungsempfaenger">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Dossier.Rechnungsempfaenger' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let item">
            {{item.Rechnungsempfaenger}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="RechnungsempfaengerAnschrift">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Dossier.RechnungsempfaengerAnschrift' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let item">
            {{item.RechnungsempfaengerAnschrift}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="Behandler">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Neuauftrag.Behandler' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let item">
            {{getPractitionerName(item.Behandler)}}</mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="caseColumns"></mat-header-row>
          <mat-row *matRowDef="let item; columns: caseColumns;" (click)="openCaseDetails(item.Id)" class="case-row"></mat-row>
        </mat-table>
      </div>
    }

    <mat-paginator
      [pageSizeOptions]="[10, 20, 50]"
      showFirstLastButtons
      aria-label="Select page of documents"
      (page)="updateValidator()">
    </mat-paginator>
  </div>
